// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import SearchBar from './SearchBar'
import SearchResult from './SearchResult'
import SearchInfoScreen from 'search/SearchInfoScreen';

import {
  CONTENT_MAX_WIDTH,
  CONTENT_MIN_WIDTH
} from 'constants/DimensionsConstants';

function SearchBody({results}) {
  const searchParagraphs = (results || []).map((hit, index) =>
    <div key={index} style={{maxWidth:CONTENT_MAX_WIDTH - 200, minWidth: CONTENT_MIN_WIDTH}}>
      {hit['results'].map((match, resultIndex) =>
        {
          return (<SearchResult key={resultIndex}
                                match={match}
                                transcriptID={hit.transcript_id}
                                name={hit.name}
                                />);
        }
      )}
    </div>
  );

  if (searchParagraphs.length == 0) {
    return <SearchInfoScreen/>
  }

  return (<div>
      {searchParagraphs}
    </div> 
  )
}

class ProjectSearch extends React.Component {
  render () {
    return (
      <div style={{height:"100%", paddingLeft:"30px", paddingBottom: 0, paddingTop:0, margin: 0, width: "100%", display: "flex", flexDirection: "column"}}>
        <div style={{flexShrink: 0}}>
          <SearchBar onSubmit={this.props.onSubmit}
                    searchText={this.props.searchText}
                    searchTerm={this.props.searchTerm}
                    onSearchTextChange={this.props.onSearchTextChange}
                    count={this.props.count}
                    total={this.props.total}
                    isLoading={this.props.isLoading}
                    isFetching={this.props.isFetching}/>
        </div>
        <div style={{flex: 1, overflow: "hidden"}}>
          <Scrollbars autoHide style={{height: "100%", padding: 10, margin: 0, width: "100%"}}>
            <SearchBody results={this.props.results}/>
          </Scrollbars>
        </div>
      </div>
    );
  }
}

export default ProjectSearch;
